import {
  Component,
  Renderer2,
  ElementRef,
  AfterViewInit,
  OnInit
} from "@angular/core";

import { BilSnackbarService } from "@core/services/bil-snackbar/bil-snackbar.service";
import { LoaderService } from "@core/services/bil-loading-service/loader.service";
import { BilNetworkService } from "@core/services/network/bil-network.service";
import { BilEventBrokerService } from "./core/services/bil-event-broker/bil-event-broker.service";
import { BilEventSnackbarOpen } from "./core/services/bil-event-broker/bil-event-broker-arguments/bil-event-snackbar-open";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../environments/environment";

@Component({
  selector: "bil-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.sass"]
})
export class AppComponent implements AfterViewInit, OnInit {
  public title = "bil-desktop";
  public url_parameters: Object;
  public isCampaignURL: boolean = false;
  public isB2CLead: boolean = false;

  constructor(
    private bilSnackbarService: BilSnackbarService,
    private renderer: Renderer2,
    private elRef: ElementRef,
    private loaderService: LoaderService,
    private bilEventBrokerService: BilEventBrokerService,
    private bilNetworkService: BilNetworkService,
    private route: ActivatedRoute,
    private router : Router
  ) {
    // console.log();
    
    if(this.router['url'] === '/') {
      if(this.route.queryParams['value']['campaign']) {
      } else {
        localStorage.removeItem("campaign")
      }
    } else {
    }
    loaderService.renderer = renderer;
    bilSnackbarService.startListening();
    this.route.queryParams.subscribe(params => {
      
      this.url_parameters = params;
      // && environment.production while going to production we have to add it
      if (this.url_parameters["campaign"]) {
        console.log('this.url_parameters["campaign"]')
        localStorage.setItem("campaign", this.url_parameters["campaign"]);
      } else if (this.url_parameters["utm_source"] && environment.production) {
        localStorage.setItem("campaign", this.url_parameters["utm_source"]);
        this.isCampaignURL = true;
      } else if(this.url_parameters["B2C"]) {
        localStorage.setItem("campaign", 'b2c');
        this.isB2CLead = true;
      }
      

      // if(this.route.queryParams){
      // } else {
      //   localStorage.removeItem('campaign')
      //   this.campaignFICCI = false;
      // }

      // if (environment.production && this.isCampaignURL) {
      //   const script1 = document.createElement("script");
      //   script1.async = true;
      //   script1.src =
      //     "https://www.googletagmanager.com/gtag/js?id=" + environment.code;

      //   var script = document.createElement("script");
      //   script.type = "text/javascript";
      //   script.innerHTML = `window.dataLayer = window.dataLayer || [];
      //                  function gtag() { dataLayer.push(arguments); }
      //                  gtag('js', new Date());
      //                  gtag('config', 'UA-143351251-4');`;
      //   document.head.prepend(script);
      // }
    });
  }

  ngOnInit() {
    this.bilNetworkService.createOnline$().subscribe(isOnline => {
      if (!isOnline) {
        this.bilEventBrokerService.publish(
          new BilEventSnackbarOpen(
            "There is no internet connection, please try again",
            "error",
            4000
          )
        );
      }
    });
  }

  ngAfterViewInit(): void {
    this.loaderService.setElementRef(this.elRef);
  }
}
